import React, { useEffect, useState } from "react";
import { Card, Row, Col, message, Button, Table, Spin, Typography, Modal } from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined, InfoCircleOutlined } from "@ant-design/icons";
import axios from "axios";
import AboutForm from "./AboutForm";
import { Link } from "react-router-dom";

const { Title } = Typography;

const AboutList = () => {
  const [aboutData, setAboutData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    fetchAboutData();
  }, []);

  const fetchAboutData = async () => {
    try {
      setLoading(true);
      const response = await axios.get("http://93.127.203.113:5005/about");
      setAboutData(response.data ? [response.data] : []); // Ensuring it's in an array format for Table
    } catch (error) {
      message.error("Failed to load about section.");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (record) => {
    setFormData(record);
    setModalVisible(true);
  };

  const handleDelete = async () => {
    try {
      await axios.delete("http://93.127.203.113:5005/about");
      message.success("About section deleted successfully.");
      fetchAboutData();
    } catch (error) {
      message.error("Failed to delete about section.");
    }
  };

  const columns = [
    { title: "Title", dataIndex: "title", key: "title" },
    { title: "Subtitle", dataIndex: "subtitle", key: "subtitle" },
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      render: (image) =>
        image ? (
          <img
            src={`http://93.127.203.113:5005${image}`}
            alt="About"
            style={{ width: "60px", height: "60px", borderRadius: "8px", objectFit: "cover" }}
          />
        ) : (
          "No Image"
        ),
    },
    {
      title: <span style={{ fontWeight: "bold", color: "#0c8c49" }}>Actions</span>,
      key: "actions",
      render: (_, record) => (
        <>
          {/* Edit Button */}
          <Button type="link" icon={<EditOutlined />} onClick={() => handleEdit(record)} style={{ color: "#0c8c49" }}>
            Edit
          </Button>

          {/* Details Link */}
          <Link to={`/aboutDetails/${record.id}`} style={{ color: "#0c8c49" }}>
              Details
            </Link>

          {/* Delete Button */}
          <Button type="link" icon={<DeleteOutlined />} onClick={handleDelete} danger style={{ marginLeft: 10 }}>
            Delete
          </Button>
        </>
      ),
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <Card style={{ borderRadius: "10px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" }}>
        <Title level={4} style={{ color: "#0c8c49", marginBottom: "20px" }}>About Section</Title>
        <Row justify="end" style={{ marginBottom: "20px" }}>
          {aboutData.length === 0 && (
            <Button type="primary" icon={<PlusOutlined />} onClick={() => setModalVisible(true)}>
              Add About Section
            </Button>
          )}
        </Row>
        {loading ? <Spin size="large" /> : <Table columns={columns} dataSource={aboutData} rowKey="id" />}
      </Card>

      <Modal visible={modalVisible} footer={null} onCancel={() => setModalVisible(false)} destroyOnClose>
        <AboutForm formData={formData} setFormData={setFormData} closeModal={() => setModalVisible(false)} refetchData={fetchAboutData} />
      </Modal>
    </div>
  );
};

export default AboutList;
